import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import { MachineContext } from "../../contexts/MachineContext";
import HeadComponent from "../../components/HeadComponent";
import CardComponent from "../../components/CardComponent";
import DiagnosticStatComponent from "../../components/DiagnosticStatComponent";
import ListItemComponent from "../../components/ListItemComponent";
import { gridSizesClassName } from "../../utils/gridSizes";
import {
  getMachineParamsValue,
  getMachineParamsComplete,
} from "../../utils/irriapp";

export default function DiagnosticScreen(props) {
  const { t } = useContext(LocalesContext);
  const { machineParams } = useContext(MachineContext);

  function hasParam(data, unit = "") {
    if (data) {
      return `${data} ${unit}`;
    }
    return "-";
  }

  // RENDER
  /////////////////////////////////////////////////////////////////////////////////////////////

  console.log(machineParams.diagnostic)

  return (
    <div className="">
      <CardComponent>
        <table className="c-table">
          <tbody>
            <tr>
              <td className="key">{t("SuperficieLavorata")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.superficieTotale, "ha")}</td>
              <td className="mobile">
                <span>
                  <p>{t("SuperficieLavorata")}</p>
                  <p>{hasParam(machineParams.diagnostic.superficieTotale, "ha")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("OreDiUtilizzo")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.tempoTotale)}</td>
              <td className="mobile">
                <span>
                  <p>{t("OreDiUtilizzo")}</p>
                  <p>{hasParam(machineParams.diagnostic.tempoTotale)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("EcuSn")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.ecuCode)}</td>
              <td className="mobile">
                <span>
                  <p>{t("EcuSn")}</p>
                  <p>{hasParam(machineParams.diagnostic.ecuCode)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("Seriale")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.seriale)}</td>
              <td className="mobile">
                <span>
                  <p>{t("Seriale")}</p>
                  <p>{hasParam(machineParams.diagnostic.seriale)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("Modello")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.modello)}</td>
              <td className="mobile">
                <span>
                  <p>{t("Modello")}</p>
                  <p>{hasParam(machineParams.diagnostic.modello)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("HWVersion")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.hwVersion)}</td>
              <td className="mobile">
                <span>
                  <p>{t("HWVersion")}</p>
                  <p>{hasParam(machineParams.diagnostic.hwVersion)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("SWVersion")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.swVersion)}</td>
              <td className="mobile">
                <span>
                  <p>{t("SWVersion")}</p>
                  <p>{hasParam(machineParams.diagnostic.swVersion)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("BTHWVersion")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.btHwVersion)}</td>
              <td className="mobile">
                <span>
                  <p>{t("BTHWVersion")}</p>
                  <p>{hasParam(machineParams.diagnostic.btHwVersion)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("BTSWVersion")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.btSwVersion)}</td>
              <td className="mobile">
                <span>
                  <p>{t("BTSWVersion")}</p>
                  <p>{hasParam(machineParams.diagnostic.btSwVersion)}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("SDCARDspace")}</td>
              <td className="value">
                {machineParams.diagnostic.sdcardSpacePercentage <= 100
                  ? `${machineParams.diagnostic.sdcardSpacePercentage} %`
                  : "-"}
              </td>
              <td className="mobile">
                <span>
                  <p>{t("SDCARDspace")}</p>
                  <p>
                    {machineParams.diagnostic.sdcardSpacePercentage <= 100
                      ? `${machineParams.diagnostic.sdcardSpacePercentage} %`
                      : "-"}
                  </p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("IngressoAnalogico1")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.extraAin1Racs, "mA")}</td>
              <td className="mobile">
                <span>
                  <p>{t("IngressoAnalogico1")}</p>
                  <p>{hasParam(machineParams.diagnostic.extraAin1Racs, "mA")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("IngressoAnalogico2")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.extraAin2, "mA")}</td>
              <td className="mobile">
                <span>
                  <p>{t("IngressoAnalogico2")}</p>
                  <p>{hasParam(machineParams.diagnostic.extraAin2, "mA")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("ADCDepressione")}</td>
              <td className="value">{hasParam(machineParams.diagnostic.adcDepressione, "mA")}</td>
              <td className="mobile">
                <span>
                  <p>{t("ADCDepressione")}</p>
                  <p>{hasParam(machineParams.diagnostic.adcDepressione, "mA")}</p>
                </span>
              </td>
            </tr>
            {/* <tr>
              <td className="key">{t("Depressione")}</td>
              <td className="value">{hasParam(machineParams.status.depression, 'mbar')}</td>
            </tr> */}
          </tbody>
        </table>
      </CardComponent>
    </div>
  );
}

DiagnosticScreen.propTypes = {
  goBack: PropTypes.func,
};

DiagnosticScreen.defaultProps = {
  goBack: () => {},
};